export default __webpack_public_path__ + "static/media/logo.e8e76d79.png";